import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT = { no_express_category_ids: [], rush_fee_percent: 50, express_minimum: 300000 };

export const useExpressRules = () => {
  const [rules, setRules] = useState(DEFAULT);
  useEffect(() => { api.get("/settings/express-rules").then(({ data }) => setRules({ ...DEFAULT, ...data })).catch(() => {}); }, []);
  return rules;
};

export const canExpress = (rules, catId) => !!catId && !(rules.no_express_category_ids || []).includes(catId);

// sama dengan Kalkulator Harga: +rush_fee_percent% (min express_minimum)
export const expressSurcharge = (rules, base) => (base > 0 ? Math.round(Math.max(+rules.express_minimum || 0, base * (+rules.rush_fee_percent || 0) / 100)) : 0);

export const expressLead = (days) => (days > 0 ? Math.max(1, Math.ceil(days / 2)) : 0);
